import { Link } from "react-router-dom";
import { videoCategories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-xl"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">樱桃视频</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              樱桃视频是集短视频、网络电影与娱乐综艺于一体的综合视频内容平台，
              致力于为用户提供高清、多元、便捷的内容浏览体验，让每一次发现都轻松愉快。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-primary-200">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-primary-200">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-primary-200">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50">内容分类</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {videoCategories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-primary-200 hover:text-background-50 transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50">关于平台</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-primary-200 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 hover:text-background-50 transition-colors">
                  合作与联系
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 hover:text-background-50 transition-colors">
                  法律声明
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 hover:text-background-50 transition-colors">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-t border-primary-800 pt-6 text-xs text-primary-300">
          <p>© 2024 樱桃视频. 本站为内容演示站点，所有视频资料均为虚构演示素材。</p>
          <p>本平台暂不提供视频播放与下载功能</p>
        </div>
      </div>
    </footer>
  );
}